import React from 'react'
import { Link, useLocation } from 'react-router-dom';

const Breadcrumb = () => {

const formatString = (str) => {
  let hyphenatedToSpaced = str.replace(/-/g, ' ');
  let result = hyphenatedToSpaced.replace(/([a-z])([A-Z])/g, '$1 $2');
  // Optional: Capitalize the first letter of the first word
  result = result.charAt(0).toUpperCase() + result.slice(1);
  return result;
};


  const location = useLocation();
  let pathSegments = location.pathname.split('/').filter(segment => segment.length > 0);
  let currentLink = '';
  const crumbs = [{ label: 'Home', link: '/' }];
  pathSegments.forEach((segment, index) => {
    currentLink += `/${segment}`;
    const label = segment.charAt(0).toLowerCase() + segment.slice(1);
    //console.log('Page Label:', label);
    crumbs.push({ label, link: currentLink });
  });
  const currentPageName = formatString(crumbs[crumbs.length - 1].label); 
    //console.log('Page Name:', currentPageName);
  return (
    <section className="page-header">
        <div className="page-header__bg"></div>
        <div className="container">
            <h2 className="page-header__title">{currentPageName}</h2>

            <ul className="growim-breadcrumb list-unstyled">
                {crumbs.map((crumb, index) => {
                const isLast = index === crumbs.length - 1;
                return (
                    <li key={crumb.link}>
                    {isLast ? (
                        <span aria-current="page">{crumb.label}</span>
                    ) : (
                        <Link to={crumb.link}>{crumb.label}</Link>
                    )}
                    </li>
                );
                })}
            </ul>

            
        </div>
    </section>
  )
}

export default Breadcrumb